/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Achievement_Early_BirdInputs */

const en_us2_achievement_early_bird = /** @type {(inputs: Achievement_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early bird`)
};

const pt_br2_achievement_early_bird = /** @type {(inputs: Achievement_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Madrugador`)
};

const es_419_achievement_early_bird = /** @type {(inputs: Achievement_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Madrugador`)
};

const pt_pt2_achievement_early_bird = /** @type {(inputs: Achievement_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Madrugador`)
};

const fr_fr2_achievement_early_bird = /** @type {(inputs: Achievement_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lève-tôt`)
};

const de_de2_achievement_early_bird = /** @type {(inputs: Achievement_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frühaufsteher`)
};

const it_it2_achievement_early_bird = /** @type {(inputs: Achievement_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mattiniero`)
};

/**
* | output |
* | --- |
* | "Early bird" |
*
* @param {Achievement_Early_BirdInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const achievement_early_bird = /** @type {((inputs?: Achievement_Early_BirdInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Achievement_Early_BirdInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_achievement_early_bird(inputs)
	if (locale === "es-419") return es_419_achievement_early_bird(inputs)
	if (locale === "pt-PT") return pt_pt2_achievement_early_bird(inputs)
	if (locale === "fr-FR") return fr_fr2_achievement_early_bird(inputs)
	if (locale === "de-DE") return de_de2_achievement_early_bird(inputs)
	if (locale === "it-IT") return it_it2_achievement_early_bird(inputs)
	return en_us2_achievement_early_bird(inputs)
});
export { achievement_early_bird as "achievement.early_bird" }